import { NgModule } from '@angular/core';

import { AutomakerRoutingModule } from './automaker.routing';
import { AutomakerFormComponent } from './components/automaker-form/automaker-form.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ListAutomakerComponent } from './list-automaker/list-automaker.component';
import { CreateAutomakerComponent } from './create-automaker/create-automaker.component';
import { UpdateAutomakerComponent } from './update-automaker/update-automaker.component';
import { ImportAutomakerOrdersComponent } from './import-automaker-orders/import-automaker-orders.component';
import { UpdateAutomakerPriceTableComponent } from './update-automaker-price-table/update-automaker-price-table.component';
import { ListAutomakerPriceTableComponent } from './list-automaker-price-table/list-automaker-price-table.component';
import { ExportFilesModalComponent } from './export-files-modal/export-files-modal.component';

@NgModule({
  declarations: [
    AutomakerFormComponent,
    ListAutomakerComponent,
    CreateAutomakerComponent,
    UpdateAutomakerComponent,
    ImportAutomakerOrdersComponent,
    UpdateAutomakerPriceTableComponent,
    ListAutomakerPriceTableComponent,
    ExportFilesModalComponent
  ],
  imports: [SharedModule, AutomakerRoutingModule]
})
export class AutomakerModule {}
